import { render, staticRenderFns } from "./RelationListItemSkeleton.vue?vue&type=template&id=2769fd50&scoped=true"
import script from "./RelationListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./RelationListItemSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2769fd50",
  null
  
)

export default component.exports